module.exports = __webpack_public_path__ + "img/nota_comercial.52caa841.svg";